import { showAlert } from "../alert/alertActions";
import { showLoader, hideLoader } from "../loader/loaderActions";
import Api from "../../service/api";
import { history, getState } from "../configure/configureStore";
import { actionTypes } from "./InstagramManagementReducer";

export function getInstagramList(data, page, limit) {
  return (dispatch) => {
    dispatch({
      type: actionTypes.GET_INSTAGRAM_LIST_PENDING,
      payload: {
        getInstagramListPending: true,
        getInstagramListSuccess: false,
        getInstagramListError: null,
      },
    });
    dispatch(showLoader());

    Api.post(`instagram/fetchReelsList?page=${page}&limit=${limit}`, data)
      .then((response) => {
        // console.log(response);
        dispatch(hideLoader());
        dispatch({
          type: actionTypes.GET_INSTAGRAM_LIST_SUCCESS,
          payload: {
            getInstagramListPending: false,
            getInstagramListSuccess: true,
            getInstagramListError: null,
            instagramList: response.data,
          },
        });
      })
      .catch((err) => {
        dispatch(hideLoader());
        dispatch({
          type: actionTypes.GET_INSTAGRAM_LIST_ERROR,
          payload: {
            getInstagramListPending: false,
            getInstagramListSuccess: false,
            getInstagramListError: null,
          },
        });
        dispatch(
          showAlert({
            isOpen: true,
            title: "Error",
            type: "danger",
            msg: "Failed to fetch instagram data",
          })
        );
      });
  };
}

export function addInstagramPublished(id, data) {
  return (dispatch) => {
    dispatch({
      type: actionTypes.ADD_INSTAGRAM_PUBLISHED_PENDING,
      payload: {
        addInstagramPublishedPending: false,
        addInstagramPublishedSuccess: false,
        addInstagramPublishedError: null,
      },
    });
    dispatch(showLoader());

    Api.post(`youtube/publishedVideos/${id}/instagram`, data)
      .then((response) => {
        if (response.message === "Video published successfully") {
          dispatch(
            showAlert({
              isOpen: true,
              title: "success",
              type: "success",
              msg: response.message,
            })
          );
        }
        // console.log(response);
        dispatch(hideLoader());
        dispatch({
          type: actionTypes.ADD_INSTAGRAM_PUBLISHED_SUCCESS,
          payload: {
            addInstagramPublishedPending: false,
            addInstagramPublishedSuccess: true,
            addInstagramPublishedError: null,
          },
        });
        dispatch(getInstagramList());
      })
      .catch((err) => {
        dispatch(hideLoader());
        dispatch({
          type: actionTypes.ADD_INSTAGRAM_PUBLISHED_ERROR,
          payload: {
            addInstagramPublishedPending: false,
            addInstagramPublishedSuccess: false,
            addInstagramPublishedError: null,
          },
        });
        dispatch(
          showAlert({
            isOpen: true,
            title: "Error",
            type: "danger",
            msg: err.message,
          })
        );
      });
  };
}
